import { CART_API_KEYS } from "features/Cart/constants/Cart.constants";
import { CHANGE_STATES } from "features/Common/modules/Form/constants/Form.constants";
import { roundOffIfDecimal } from "features/Common/modules/DataTypes/utils/numbers";
import { is_empty } from "features/Common/utils/common.utils";
import {
  CREDIT_PAYMENT_TYPE,
  SUBSCRIPTION_MIN_PAYABLE_AMOUNT,
} from "features/MySubscriptions/constants/MySubscriptions.constants";

export const getActiveCartItems = (cart = {}) =>
  Object.values(cart).filter(
    (item) => item?.feature_key && item.change_state !== CHANGE_STATES.deleted
  );

export const isSubscriptionPaymentCart = (cartList = []) =>
  cartList.some(
    (item) =>
      item?.[CART_API_KEYS.credit_payment_type] ===
      CREDIT_PAYMENT_TYPE.RECURRING
  );

export const canShowWalletForCart = ({
  isSubscriptionPaymentCart,
  grossAmount,
  isWalletActive,
}) => {
  if (!isWalletActive) return false;

  if (!isSubscriptionPaymentCart) return true;

  return grossAmount >= SUBSCRIPTION_MIN_PAYABLE_AMOUNT;
};

export const getDisplayWalletBalance = ({
  isSubscriptionPaymentCart,
  grossAmount,
  walletBalance = 0,
}) => {
  const balance = parseFloat(walletBalance) || 0;

  const displayAmount = !isSubscriptionPaymentCart
    ? balance
    : Math.min(
        balance,
        Math.max(0, grossAmount - SUBSCRIPTION_MIN_PAYABLE_AMOUNT)
      );

  return roundOffIfDecimal(displayAmount, 2);
};

export const buildCartPayloadFromItems = (items = []) => {
  const payload = {};

  items.forEach((item) => {
    if (item?.feature_key) {
      payload[item.feature_key] = item;
    }
  });

  return payload;
};

/**
 * Maps cart line to cart/update API payload.
 * EntityChangeState: NO_CHANGE=0, UPDATED=1, NEW_ADDED=2, DELETED=3 (see CHANGE_STATES).
 */
export const buildCartApiItem = (item) => {
  const change_state =
    typeof item?.change_state === "number"
      ? item.change_state
      : is_empty(item.uuid)
      ? CHANGE_STATES.added
      : CHANGE_STATES.updated;

  const apiItem = {
    feature_key: item.feature_key,
    price: item.price,
    credit_plan_id: item.credit_plan_id,
    quantity: item.quantity ?? 1,
    units: item.units ?? 1,
    processing: false,
    change_state,
  };

  // NEW_ADDED must not send uuid; other states include uuid when present.
  if (item.uuid && change_state !== CHANGE_STATES.added) {
    apiItem.uuid = item.uuid;
  }

  return apiItem;
};
